export default "__VITE_ASSET__dcd49127__"